<template>
<div>
  <Modal v-model="visible" title="导出" :footer-hide="true" width="600px" class="my-modal p-b">
    <div class="tools-box" style="margin-top:20px">
      <span>导出进度</span>
      <Button type="primary" @click="download" :loading="loading" style="width:auto">确认导出</Button>
    </div>
    <Progress :percent="progress" status="active" />
    <Button type="primary" @click="$refs.daochuConfigModal.open(type)" style="margin-top:20px">模板表头配置</Button>
  </Modal>
  <!-- 导出配置  -->
  <daochu-config-modal ref="daochuConfigModal"></daochu-config-modal>
</div>
</template>

<script>
import daochuConfigModal from "./daochuConfigModal";
export default {
  components: {
    daochuConfigModal
  },
  props: [],
  data() {
    return {
      visible:false,
      progress:0,
      type:'',
      params: {},
      loading: false,
      timer:{}
    };
  },
  computed: {
  },
  created() {},
  methods: {
    open(data={}, type) {
      if(type == 'zeroInsure') {
        this.params = data;
      }else{
        this.params = this.$parent.initFilterObj();
      }
      this.visible = true;
      this.progress = 0;
      this.loading = false;
      this.type = type
      window.clearInterval(this.timer);
    },
    download(){
      this.loading = true;
      this.progressStart();
      let url;
      if(this.type =='isAbnormal'){
        url ='/buz/policyAbnormal/policyExport'
      }else{
        url = `/buz/policy/policyExport`
      }
      this.$http({
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        url: url,
        data: this.params,
        apiPermissionCode:'order_30_4'
      }).then(res => {
        this.loading = false;
        window.clearInterval(this.timer);
        if (res.headers['content-type'].includes('json')) {
          // 此处拿到的data才是blob
          const { data } = res
          const reader = new FileReader()
          reader.onload = () => {
            const { result } = reader
            const errorInfos = JSON.parse(result)
            const { msg } = errorInfos
            this.$notice.error(msg)
          }
          reader.onerror = err => {
            reject(err)
          }
          reader.readAsText(data)
        } else {
          this.$units.daochu(res);
          this.progress = 100;
        }
      }).catch(e=>{
        console.log(e);
        this.loading = false;
        window.clearInterval(this.timer);
      }) 
    },
    progressStart(){
      this.progress = 0;
      window.clearInterval(this.timer);
      this.timer = window.setInterval(()=>{
        const arr = [1,3,5];
        const progress = this.progress + arr[Date.now()%3];
        if(progress>=100){
          window.clearInterval(this.timer);
          this.progress = 99
        }else{
          this.progress = progress
        }
      },2000)
    }
  },
};
</script>
<style lang="scss" scoped>

</style>
